import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export interface FaqItem {
  question: string;
  answer: string;
  order: number;
}

export interface FaqCategory {
  category: string;
  icon: string;
  order: number;
  items: FaqItem[];
}

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  private readonly apiUrl = `${environment.apiUrl}/api/faq`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<FaqCategory[]> {
    return this.http.get<FaqCategory[]>(this.apiUrl);
  }

  search(keyword: string): Observable<FaqCategory[]> {
    const params = new HttpParams().set('keyword', keyword);
    return this.http.get<FaqCategory[]>(`${this.apiUrl}/search`, { params });
  }
}
